import React from 'react'

interface IProps {}

export const IconDate: React.FC<IProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="56"
      fill="none"
      viewBox="0 0 24 56"
    >
      <path fill="url(#pattern0_11635_9383)" d="M0 0H24V56H0z"></path>
      <defs>
        <pattern
          id="pattern0_11635_9383"
          width="1"
          height="1"
          patternContentUnits="objectBoundingBox"
        >
          <use transform="matrix(.01042 0 0 .00446 0 .286)" xlinkHref="#image0_11635_9383"></use>
        </pattern>
        <image
          id="image0_11635_9383"
          width="96"
          height="96"
          xlinkHref="data:image/png;base64,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"
        ></image>
      </defs>
    </svg>
  )
}
